"use strict";

exports.__esModule = true;
function convertToArray(lsv) {
  var lines = lsv.split(/\n/);
  var attachments = [];
  for (var i = 0; i < lines.length; i++) {
    if (/\S/.test(lines[i])) {
      attachments.push(lines[i].trim());
    }
  }
  return attachments;
}
exports.convertToArray = convertToArray;
function convertToLSV(arr) {
  return arr.join('\n');
}
exports.convertToLSV = convertToLSV;